import { render, staticRenderFns } from "./GymPosition.vue?vue&type=template&id=1a4fcd0d&scoped=true&"
import script from "./GymPosition.vue?vue&type=script&lang=js&"
export * from "./GymPosition.vue?vue&type=script&lang=js&"
import style0 from "./GymPosition.vue?vue&type=style&index=0&id=1a4fcd0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4fcd0d",
  null
  
)

export default component.exports